import axios from 'axios';
import { URLS } from '@constants/urls';
import userAppApi from '@helpers/userAppApi';

export const getElections = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async (): Promise<{ data: any }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;

    return userAppApi
      .get(URLS.GET_ELECTIONS)
      .then((response) => {
        return { data: response.data };
      })
      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
